export const baseApiUrl = process.env.NODE_ENV === "development" ? 'https://192.168.1.180/api' : '/api';
//console.log('baseApiUrl',baseApiUrl);

// тестовый 'https://192.168.1.180/api'
// http://localhost:35020